<template>
<ItpBox
  alignItems="center"
  v-if="loaded"
>
  <ItpFormSelect
    name="date_type"
    v-model="item.date_type"
    :placeholder="'date filter type'|pgettext('Invoices')"
    :options="b_2248226175642056_options"
    class="mx-2 my-1 w-auto"
  >
  </ItpFormSelect>
  <DateRangeSelector
    name="invoiceFilters"
    :from="item.date_from"
    :to="item.date_to"
    class="mx-2 my-1"
    @changed="evh_5962862420439144_changed($event, {})"
  >
    <ItpText
      :text="'Unpaid'|pgettext('Invoices')"
    >
    </ItpText>
  </DateRangeSelector>
  <ItpFormCheckbox
    name="unpaid"
    inline
    v-model="item.unpaid"
    class="mx-2 my-1"
  >
    <ItpText
      :text="'Unpaid'|pgettext('Invoices')"
    >
    </ItpText>
  </ItpFormCheckbox>
  <ItpButton
    :icon="$config.reloadIcon"
    :text="'Load'|gettext"
    variant="light"
    class="mx-2 my-1"
    @click.prevent.stop="evh_1048678296148443_clickPreventStop($event, {})"
  >
  </ItpButton>
</ItpBox>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class InvoicesFilters extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
    this.$$cache_item = new ComponentValueCache(this, "item", "InvoicesFilters");
  }

  item!: any;

  async $$load_item() {
    return {
      date_from: null,
      date_to: null,
      unpaid: false,
      kind: this.kind,
      date_type: "invoice_date",
    }
  }

  ux!: any;
  b_2248226175642056_options!: any;
  dataMembers = ['item', 'ux', 'b_2248226175642056_options'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        item: null,
        ux: null,
        b_2248226175642056_options: [{
          value: "invoice_date",
          text: this.$fn.pgettext("Invoice", "Invoice date"),
        }
          ,
        {
          value: "fulfillment_date",
          text: this.$fn.pgettext("Invoice", "Fulfillment date"),
        }
          ,
        {
          value: "due_date",
          text: this.$fn.pgettext("Invoice", "Due date"),
        }
          ,
        ]
        ,
      },
    }
  }

  async act_5962862420439144_setData_7774_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_5962862420439144_setData_7774, alias=undefined
    return {
      path: "item.date_from",
      value: $event.data[0],
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async act_5962862420439144_setData_7776_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_5962862420439144_setData_7776, alias=undefined
    return {
      path: "item.date_to",
      value: $event.data[1],
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async evh_5962862420439144_changed(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5962862420439144_changed.executeFromDOM(this, event, scope);
  }

  async act_1048678296148443_emit_7778_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_1048678296148443_emit_7778, alias=undefined
    return {
      event: "submit",
      value: { ...this.item, kind: this.kind },
    }
  }

  async evh_1048678296148443_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1048678296148443_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_5962862420439144_setData_7774: actions.SetDataAction;
    evh_5962862420439144_changed_7773: actions.EventHandlerImpl;
    act_5962862420439144_setData_7776: actions.SetDataAction;
    evh_5962862420439144_changed_7775: actions.EventHandlerImpl;
    evh_5962862420439144_changed: actions.EventHandlerGroup;
    act_1048678296148443_emit_7778: actions.EmitAction;
    evh_1048678296148443_clickPreventStop_7777: actions.EventHandlerImpl;
    evh_1048678296148443_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_5962862420439144_setData_7774 = new actions.SetDataAction(
      {
        actionArgs: this.act_5962862420439144_setData_7774_getActionArgs,
        events: [],
      }
    );
    const evh_5962862420439144_changed_7773 = new actions.EventHandlerImpl(
      {
        action: act_5962862420439144_setData_7774,
        event: "changed",
        displayName: "setData",
      }
    );
    const act_5962862420439144_setData_7776 = new actions.SetDataAction(
      {
        actionArgs: this.act_5962862420439144_setData_7776_getActionArgs,
        events: [],
      }
    );
    const evh_5962862420439144_changed_7775 = new actions.EventHandlerImpl(
      {
        action: act_5962862420439144_setData_7776,
        event: "changed",
        displayName: "setData",
      }
    );
    const evh_5962862420439144_changed = new actions.EventHandlerGroup(
      {
        handlers: [evh_5962862420439144_changed_7773, evh_5962862420439144_changed_7775],
      }
    );
    const act_1048678296148443_emit_7778 = new actions.EmitAction(
      {
        actionArgs: this.act_1048678296148443_emit_7778_getActionArgs,
        events: [],
      }
    );
    const evh_1048678296148443_clickPreventStop_7777 = new actions.EventHandlerImpl(
      {
        action: act_1048678296148443_emit_7778,
        event: "click.prevent.stop",
        displayName: "emit",
      }
    );
    const evh_1048678296148443_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1048678296148443_clickPreventStop_7777],
      }
    );
    return {
      act_5962862420439144_setData_7774,
      evh_5962862420439144_changed_7773,
      act_5962862420439144_setData_7776,
      evh_5962862420439144_changed_7775,
      evh_5962862420439144_changed,
      act_1048678296148443_emit_7778,
      evh_1048678296148443_clickPreventStop_7777,
      evh_1048678296148443_clickPreventStop,
    }
  }
}

Vue.component("InvoicesFilters", InvoicesFilters);

</script>